<div class="flex flex-col gap-5 p-5">
  <!-- Sección de la cabecera. -->
  <section class="w-full flex flex-col items-center gap-5">
    <div class="text-2xl font-medium text-center">Eliminar un host</div>
    <p class="w-10/12 text-center">
      ¿Estás seguro de que quieres eliminar el host? Esta opción es
      irreversible.
    </p>
  </section>

  <!-- Sección del cuerpo. -->
  <section class="flex flex-col gap-5">
    <!-- Errores. -->
    @if (errors) {
    <div class="flex flex-col gap-2 text-center">
      @for (error of errors; track error) {
      <span class="text-sm text-red-500">{{ error }}</span>
      }
    </div>
    }

    <!-- Botones de acción. -->
    <div class="flex gap-5 justify-center">
      <button
        type="button"
        mat-raised-button
        [disabled]="loading"
        (click)="dialogRef.close()"
      >
        <span class="text-base">Cancelar</span>
      </button>
      <button
        type="button"
        mat-flat-button
        [disabled]="loading"
        (click)="delete()"
      >
        @if (loading) {
        <mat-spinner diameter="18"></mat-spinner>
        } @else {
        <span class="text-base">Eliminar</span>
        }
      </button>
    </div>
  </section>
</div>
